import React, { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { useLocation } from "react-router-dom";
import { baseURL } from "./api";
import axios from "./Services/Api";

// ── Inject styles once ────────────────────────────────────────────────────────
const injectStyles = () => {
  if (document.getElementById("inv-styles")) return;
  const s = document.createElement("style");
  s.id = "inv-styles";
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700&family=DM+Mono:wght@400;500&display=swap');

    :root {
      --bg:          #f0efe9;
      --surface:     #ffffff;
      --surface2:    #f7f6f2;
      --border:      #e5e2db;
      --accent:      #c0502a;
      --accent-soft: #f8ece7;
      --accent-dark: #9e3e1f;
      --text:        #18160f;
      --muted:       #888278;
      --green:       #2b7a4b;
      --green-soft:  #e6f4ee;
      --amber:       #b06000;
      --amber-soft:  #fff3e0;
      --r:           14px;
      --r-sm:        8px;
      --sh:          0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
      --sh-md:       0 4px 18px rgba(0,0,0,.09);
    }

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    .inv { font-family: 'DM Sans', sans-serif; background: var(--bg); min-height: 100vh; padding: 28px; color: var(--text); }

    /* ── Header ── */
    .inv-hd { margin-bottom: 26px; }
    .inv-hd-title { font-size: 24px; font-weight: 700; letter-spacing: -.5px; }
    .inv-hd-title em { font-style: normal; color: var(--accent); }
    .inv-hd-sub { font-size: 12.5px; color: var(--muted); margin-top: 3px; }

    /* ── Stat strip ── */
    .inv-stats { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 22px; }
    .inv-stat { background: var(--surface); border: 1px solid var(--border); border-radius: var(--r); padding: 14px 20px; flex: 1 1 130px; box-shadow: var(--sh); }
    .inv-stat-lbl { font-size: 10px; font-weight: 700; letter-spacing: .9px; text-transform: uppercase; color: var(--muted); margin-bottom: 6px; }
    .inv-stat-val { font-size: 26px; font-weight: 700; font-family: 'DM Mono', monospace; letter-spacing: -1px; line-height: 1; }
    .inv-stat-sub { font-size: 11px; color: var(--muted); margin-top: 3px; }
    .inv-stat.a .inv-stat-val { color: var(--accent); }
    .inv-stat.g .inv-stat-val { color: var(--green); }

    /* ── Toolbar ── */
    .inv-bar { background: var(--surface); border: 1px solid var(--border); border-radius: var(--r); padding: 14px 18px; margin-bottom: 18px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; box-shadow: var(--sh); }
    .inv-bar-lbl { font-size: 11px; font-weight: 700; letter-spacing: .6px; text-transform: uppercase; color: var(--muted); white-space: nowrap; }
    .inv-sel-wrap { position: relative; }
    .inv-sel { appearance: none; background: var(--surface2); border: 1.5px solid var(--border); border-radius: var(--r-sm); padding: 7px 32px 7px 12px; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 500; color: var(--text); cursor: pointer; outline: none; transition: border-color .15s, box-shadow .15s; min-width: 170px; }
    .inv-sel:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(192,80,42,.12); }
    .inv-sel-arr { position: absolute; right: 9px; top: 50%; transform: translateY(-50%); pointer-events: none; color: var(--muted); font-size: 9px; }
    .inv-div { width: 1px; height: 24px; background: var(--border); flex-shrink: 0; }
    .inv-chips { display: flex; gap: 6px; flex-wrap: wrap; }
    .inv-chip { padding: 4px 13px; border-radius: 999px; font-size: 11.5px; font-weight: 600; border: 1.5px solid var(--border); background: var(--surface2); color: var(--muted); cursor: pointer; transition: all .14s; white-space: nowrap; }
    .inv-chip:hover { border-color: var(--accent); color: var(--accent); }
    .inv-chip.on { background: var(--accent); border-color: var(--accent); color: #fff; box-shadow: 0 2px 8px rgba(192,80,42,.28); }

    /* ── Cards list ── */
    .inv-list { display: flex; flex-direction: column; gap: 10px; }

    .inv-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--r); box-shadow: var(--sh); transition: box-shadow .18s; overflow: hidden; }
    .inv-card:hover { box-shadow: var(--sh-md); }
    .inv-card.editing { border-color: var(--accent); box-shadow: 0 0 0 2px var(--accent-soft), var(--sh-md); }

    /* card top row */
    .inv-card-top { display: flex; align-items: center; gap: 14px; padding: 14px 18px; }
    .inv-card-img { width: 52px; height: 52px; border-radius: var(--r-sm); object-fit: cover; border: 1px solid var(--border); flex-shrink: 0; background: var(--surface2); }
    .inv-card-img-ph { width: 52px; height: 52px; border-radius: var(--r-sm); background: var(--surface2); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; }
    .inv-card-info { flex: 1; min-width: 0; }
    .inv-card-name { font-weight: 600; font-size: 14.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .inv-card-meta { font-size: 11px; color: var(--muted); font-family: 'DM Mono', monospace; margin-top: 2px; }
    .inv-card-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

    /* badge */
    .inv-bdg { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; font-size: 11.5px; font-weight: 600; }
    .inv-bdg.out  { background: #f2f1ee; color: var(--muted); }
    .inv-bdg.low  { background: var(--amber-soft); color: var(--amber); }
    .inv-bdg.ok   { background: var(--green-soft); color: var(--green); }

    /* edit btn */
    .inv-edit-btn { padding: 5px 16px; border-radius: var(--r-sm); font-size: 12px; font-weight: 600; border: 1.5px solid var(--border); background: var(--surface2); color: var(--muted); cursor: pointer; transition: all .14s; white-space: nowrap; }
    .inv-edit-btn:hover { border-color: var(--accent); color: var(--accent); background: var(--accent-soft); }
    .inv-edit-btn.on { border-color: var(--accent); background: var(--accent); color: #fff; }

    /* unit grid inside card */
    .inv-units { display: flex; flex-wrap: wrap; gap: 8px; padding: 0 18px 14px 18px; }

    .inv-unit { display: flex; flex-direction: column; gap: 5px; background: var(--surface2); border: 1.5px solid var(--border); border-radius: var(--r-sm); padding: 10px 12px; min-width: 110px; transition: border-color .14s; }
    .inv-unit.edited { border-color: var(--accent); background: var(--accent-soft); }
    .inv-unit-lbl { font-size: 10px; font-weight: 700; letter-spacing: .7px; text-transform: uppercase; color: var(--muted); }
    .inv-unit-lbl.edited { color: var(--accent); }
    .inv-unit-row { display: flex; align-items: center; gap: 6px; }
    .inv-unit-input { width: 72px; padding: 6px 8px; border: 1.5px solid var(--border); border-radius: 6px; font-family: 'DM Mono', monospace; font-size: 15px; font-weight: 500; color: var(--text); background: var(--surface); outline: none; text-align: center; transition: border-color .14s, box-shadow .14s; -moz-appearance: textfield; }
    .inv-unit-input::-webkit-outer-spin-button,
    .inv-unit-input::-webkit-inner-spin-button { -webkit-appearance: none; }
    .inv-unit-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(192,80,42,.12); }
    .inv-unit-input:disabled { opacity: .5; cursor: not-allowed; background: var(--surface2); }
    .inv-stp { width: 24px; height: 24px; border-radius: 6px; border: 1.5px solid var(--border); background: var(--surface); cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; line-height: 1; color: var(--muted); transition: all .12s; font-weight: 700; flex-shrink: 0; }
    .inv-stp:hover { border-color: var(--accent); color: var(--accent); background: var(--accent-soft); }

    /* ── Save bar ── */
    .inv-save { display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin-top: 18px; }
    .inv-pill { font-size: 12px; font-weight: 600; color: var(--accent); background: var(--accent-soft); padding: 5px 14px; border-radius: 999px; }
    .inv-btn { padding: 9px 22px; border-radius: var(--r-sm); font-family: 'DM Sans', sans-serif; font-size: 13.5px; font-weight: 600; border: none; cursor: pointer; transition: all .15s; }
    .inv-btn.sec { background: var(--surface); border: 1.5px solid var(--border); color: var(--muted); }
    .inv-btn.sec:hover { border-color: var(--text); color: var(--text); }
    .inv-btn.pri { background: var(--accent); color: #fff; box-shadow: 0 2px 8px rgba(192,80,42,.28); }
    .inv-btn.pri:hover { background: var(--accent-dark); transform: translateY(-1px); box-shadow: 0 4px 14px rgba(192,80,42,.36); }
    .inv-btn.pri:disabled { background: #d8a898; box-shadow: none; cursor: not-allowed; transform: none; }

    /* ── States ── */
    .inv-empty { text-align: center; padding: 60px 20px; color: var(--muted); }
    .inv-empty-icon { font-size: 46px; margin-bottom: 12px; opacity: .45; }
    .inv-empty-txt { font-size: 15px; font-weight: 500; }
    .inv-loading { text-align: center; padding: 60px; color: var(--muted); font-size: 14px; }

    @media (max-width: 600px) {
      .inv { padding: 14px; }
      .inv-stats { flex-wrap: wrap; }
      .inv-stat { flex: 1 1 calc(50% - 6px); }
      .inv-unit { min-width: 90px; }
      .inv-stp { display: none; }
    }
  `;
  document.head.appendChild(s);
};

// ── Badge ─────────────────────────────────────────────────────────────────────
const Badge = ({ total }) => {
  if (total === 0) return <span className="inv-bdg out">✕ Out of stock</span>;
  if (total < 10)  return <span className="inv-bdg low">▲ Low stock</span>;
  return <span className="inv-bdg ok">● In stock</span>;
};

// ── Component ─────────────────────────────────────────────────────────────────
const InventoryManagement = () => {
  injectStyles();
  const location = useLocation();

  const [restaurants,        setRestaurants]        = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [menuItems,          setMenuItems]          = useState([]);
  const [stockData,          setStockData]          = useState({});
  const [dynamicUnits,       setDynamicUnits]       = useState([]);
  const [updatedStock,       setUpdatedStock]       = useState({});
  const [editableRows,       setEditableRows]       = useState({});
  const [availableBatches,   setAvailableBatches]   = useState([]);
  const [selectedBatch,      setSelectedBatch]      = useState("All");
  const [isModalVisible,     setIsModalVisible]     = useState(false);
  const [loading,            setLoading]            = useState(false);

  const currentVendorId = localStorage.getItem("vendorId");

  const fetchRestaurants = async () => {
    try {
      const { data } = await axios.get("/getRestaurants");
      const mine = data.filter((r) => r.vendorId === currentVendorId);
      const def  = data.find((r) => r.default === true);
      const list = [...mine];
      if (def && def.vendorId !== currentVendorId) list.push(def);
      setRestaurants(list);
      if (list.length > 0) {
        const sel = def && def.vendorId === currentVendorId ? def._id : list[0]._id;
        setSelectedRestaurant(sel);
        fetchMenuItems(sel);
      }
    } catch { message.error("Failed to fetch restaurants."); }
  };

  useEffect(() => {
    fetchRestaurants();
    if (location.pathname === "/addmenu") setIsModalVisible(true);
  }, [location.pathname]);

  const fetchMenuItems = async (restaurantId) => {
    setLoading(true);
    try {
      const { data: itemsData } = await axios.get(`/getMenuItems?restaurantId=${restaurantId}`);
      const { data: stockRes  } = await axios.get(`/getStock?restaurantId=${restaurantId}`);

      setMenuItems(itemsData);

      const stockMap   = {};
      const allUnits   = new Set();
      const allBatches = new Set();

      (stockRes.stock || []).forEach((s) => {
        const menuId = typeof s.menuItemId === "object" ? s.menuItemId._id : s.menuItemId;

        // Support both new (stockByUnit) and old (stock1kg / stock500gm) shapes
        const stockByUnit = s.stockByUnit
          ? { ...s.stockByUnit }
          : {
              ...(s.stock1kg    != null && { "1 kg":    s.stock1kg    }),
              ...(s.stock500gm  != null && { "500 gm":  s.stock500gm  }),
              ...(s.stock5piece != null && { "5 piece": s.stock5piece }),
            };

        Object.keys(stockByUnit).forEach((u) => allUnits.add(u));
        s.batches?.forEach((b) => {
          allBatches.add(b.batch);
          Object.keys(b.stockByUnit || {}).forEach((u) => allUnits.add(u));
        });

        stockMap[menuId] = { stockByUnit, batches: s.batches || [] };
      });

      // Backend may also send a top-level units array
      if (stockRes.units?.length) stockRes.units.forEach((u) => allUnits.add(u));

      setStockData(stockMap);
      setDynamicUnits([...allUnits]);
      setAvailableBatches(["All", ...Array.from(allBatches)]);
      setSelectedBatch("All");
      setUpdatedStock({});
      setEditableRows({});
    } catch { message.error("Failed to fetch menu items or stock."); }
    finally { setLoading(false); }
  };

  const getFilteredUnit = (menuId, unit) => {
    const item = stockData[menuId];
    if (!item) return 0;
    if (selectedBatch === "All") return item.stockByUnit?.[unit] || 0;
    return (item.batches || [])
      .filter((b) => b.batch === selectedBatch)
      .reduce((sum, b) => sum + (b.stockByUnit?.[unit] || 0), 0);
  };

  const getVal    = (menuId, unit) => updatedStock[menuId]?.[unit] ?? getFilteredUnit(menuId, unit);
  const isEdited  = (menuId, unit) => updatedStock[menuId]?.[unit] !== undefined;

  const handleChange = (menuId, unit, raw) => {
    const val = Math.max(0, parseInt(raw, 10) || 0);
    setUpdatedStock((p) => ({ ...p, [menuId]: { ...p[menuId], [unit]: val } }));
  };

  const step = (menuId, unit, delta) =>
    handleChange(menuId, unit, getVal(menuId, unit) + delta);

  // Per-unit totals for stat cards
  const unitTotals = dynamicUnits.reduce((acc, unit) => {
    acc[unit] = menuItems.reduce((sum, item) => sum + getVal(item._id, unit), 0);
    return acc;
  }, {});

  const changeCount = Object.keys(updatedStock).length;

  const handleSave = async () => {
    if (!selectedRestaurant) { message.error("No restaurant selected."); return; }
    if (!changeCount) { message.warning("No changes to save."); return; }
    try {
      const stockUpdates = Object.entries(updatedStock).map(([itemId, units]) => ({
        itemId,
        stockByUnit: Object.fromEntries(
          Object.entries(units).map(([unit, qty]) => [unit, Number(qty)])
        ),
      }));
      await axios.post("/updateStock", { restaurantId: selectedRestaurant, stockUpdates });
      message.success("Stock updated!");
      fetchMenuItems(selectedRestaurant);
    } catch { message.error("Failed to update stock."); }
  };

  return (
    <div className="inv">
      {/* Header */}
      <div className="inv-hd">
        <div className="inv-hd-title">Inventory <em>Management</em></div>
        <div className="inv-hd-sub">Track and update stock levels across all menu items</div>
      </div>

      {/* Stat strip — one card per unit type */}
      <div className="inv-stats">
        {dynamicUnits.map((unit, i) => (
          <div key={unit} className={`inv-stat ${i === 0 ? "a" : i === 1 ? "g" : ""}`}>
            <div className="inv-stat-lbl">{unit}</div>
            <div className="inv-stat-val">{unitTotals[unit] ?? 0}</div>
            <div className="inv-stat-sub">pkts in stock</div>
          </div>
        ))}
        <div className="inv-stat">
          <div className="inv-stat-lbl">Menu Items</div>
          <div className="inv-stat-val">{menuItems.length}</div>
          <div className="inv-stat-sub">total items</div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="inv-bar">
        <span className="inv-bar-lbl">Restaurant</span>
        <div className="inv-sel-wrap">
          <select
            className="inv-sel"
            value={selectedRestaurant || ""}
            onChange={(e) => {
              setSelectedRestaurant(e.target.value);
              if (e.target.value) fetchMenuItems(e.target.value);
              else { setMenuItems([]); setStockData({}); }
            }}
          >
            {restaurants.map((r) => <option key={r._id} value={r._id}>{r.name}</option>)}
          </select>
          <span className="inv-sel-arr">▼</span>
        </div>

        {availableBatches.length > 1 && (
          <>
            <div className="inv-div" />
            <span className="inv-bar-lbl">Batch</span>
            <div className="inv-chips">
              {availableBatches.map((b) => (
                <button
                  key={b}
                  className={`inv-chip ${selectedBatch === b ? "on" : ""}`}
                  onClick={() => setSelectedBatch(b)}
                >
                  {b === "All" ? "All Batches" : `Batch ${b}`}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Content */}
      {loading ? (
        <div className="inv-loading">Loading stock data…</div>
      ) : menuItems.length === 0 ? (
        <div className="inv-empty">
          <div className="inv-empty-icon">📦</div>
          <div className="inv-empty-txt">No menu items added yet</div>
        </div>
      ) : (
        <>
          <div className="inv-list">
            {menuItems.map((item) => {
              const editable  = !!editableRows[item._id];
              // In view mode: only show units with stock > 0
              // In edit mode: show all known units so new ones can be filled
              const visibleUnits = editable
                ? dynamicUnits
                : dynamicUnits.filter((u) => getVal(item._id, u) > 0 || isEdited(item._id, u));

              const totalQty = dynamicUnits.reduce((s, u) => s + getVal(item._id, u), 0);

              return (
                <div key={item._id} className={`inv-card ${editable ? "editing" : ""}`}>
                  {/* Top: image · name · badge · edit */}
                  <div className="inv-card-top">
                    {item.imgPath
                      ? <img className="inv-card-img" src={`${baseURL}/${item.imgPath}`} alt={item.name} />
                      : <div className="inv-card-img-ph">🍱</div>
                    }
                    <div className="inv-card-info">
                      <div className="inv-card-name">{item.name}</div>
                      <div className="inv-card-meta">
                        ID …{item._id.slice(-6)}
                        {visibleUnits.length > 0 && (
                          <> &nbsp;·&nbsp; {visibleUnits.length} unit type{visibleUnits.length !== 1 ? "s" : ""}</>
                        )}
                      </div>
                    </div>
                    <div className="inv-card-right">
                      <Badge total={totalQty} />
                      <button
                        className={`inv-edit-btn ${editable ? "on" : ""}`}
                        onClick={() => setEditableRows((p) => ({ ...p, [item._id]: !p[item._id] }))}
                      >
                        {editable ? "✓ Done" : "Edit"}
                      </button>
                    </div>
                  </div>

                  {/* Unit chips */}
                  {visibleUnits.length > 0 && (
                    <div className="inv-units">
                      {visibleUnits.map((unit) => {
                        const val    = getVal(item._id, unit);
                        const edited = isEdited(item._id, unit);
                        return (
                          <div key={unit} className={`inv-unit ${edited ? "edited" : ""}`}>
                            <div className={`inv-unit-lbl ${edited ? "edited" : ""}`}>{unit}</div>
                            <div className="inv-unit-row">
                              {editable && (
                                <button className="inv-stp" onClick={() => step(item._id, unit, -1)}>−</button>
                              )}
                              <input
                                className="inv-unit-input"
                                type="number"
                                min="0"
                                value={val}
                                disabled={!editable}
                                onChange={(e) => handleChange(item._id, unit, e.target.value)}
                              />
                              {editable && (
                                <button className="inv-stp" onClick={() => step(item._id, unit, 1)}>+</button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Save bar */}
          <div className="inv-save">
            {changeCount > 0 && (
              <span className="inv-pill">{changeCount} unsaved change{changeCount > 1 ? "s" : ""}</span>
            )}
            <button
              className="inv-btn sec"
              onClick={() => { setUpdatedStock({}); setEditableRows({}); }}
            >
              Discard
            </button>
            <button className="inv-btn pri" onClick={handleSave} disabled={changeCount === 0}>
              Save Stock
            </button>
          </div>
        </>
      )}

      <Modal title="Add Menu" open={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null}>
        {/* Modal form here */}
      </Modal>
    </div>
  );
};

export default InventoryManagement;